<template>
  <!-- Thin wrapper over ui/ConfirmDialog so legacy call sites (title/body/
       showModal/loading + confirm/cancel) keep working while inheriting the
       primitive's dialog semantics, focus trap and Escape handling. -->
  <ConfirmDialog
    :show="showModal"
    :title="title"
    :message="body"
    :loading="loading"
    :confirm-label="confirmLabel"
    :cancel-label="cancelLabel"
    danger
    @confirm="confirm"
    @cancel="cancel"
  />
</template>

<script>
import ConfirmDialog from "@/components/ui/ConfirmDialog.vue";

export default {
  name: "DeleteRecordDialog",
  components: { ConfirmDialog },
  props: {
    title: {
      type: String,
      required: true,
    },
    body: {
      type: String,
      required: true,
    },
    showModal: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    confirmLabel: {
      type: String,
      default: "Confirm",
    },
    cancelLabel: {
      type: String,
      default: "Cancel",
    },
  },
  emits: ["confirm", "cancel"],
  setup(props, { emit }) {
    const confirm = () => {
      if (props.loading) return;
      emit("confirm");
    };
    // Guard also covers Escape and the header close button so the dialog
    // cannot be dismissed mid-request.
    const cancel = () => {
      if (props.loading) return;
      emit("cancel");
    };
    return { confirm, cancel };
  },
};
</script>
